// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6048") return "static/css/6048.b0951e4c.css";
if (chunkId === "367") return "static/css/367.24aba765.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}